module.exports = __webpack_public_path__ + "media/images/ns-app-header-white-logo4-070f9d438b56a90901e9457d13981eef.svg";